import { faCalendar, faList } from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@mantine/core'
import { useRouter } from 'next/router'

import { Icon } from '@flecto/ui'
import useMediaQuery from '@flecto/ui/lib/utils/useMediaQuery'

export function TogglePageScheduler() {
  const { isMobile } = useMediaQuery()

  const router = useRouter()
  const isTimeline = router.pathname === '/schedule/timeline'

  if (isMobile) {
    return
  }

  return (
    <Button.Group>
      <Button
        variant={!isTimeline ? 'filled' : 'default'}
        onClick={() => router.push('/schedule')}
      >
        <Icon icon={faList} />
      </Button>
      <Button
        variant={isTimeline ? 'filled' : 'default'}
        onClick={() => router.push('/schedule/timeline')}
      >
        <Icon icon={faCalendar} />
      </Button>
    </Button.Group>
  )
}
